import { useForm } from "@inertiajs/react";
import get from "lodash/get";

export default function useFieldArray(
  form: ReturnType<typeof useForm>,
  fieldName: string
) {
  function append(initialValues = {}) {
    form.setData((previousData: Record<any, any>) => ({
      ...previousData,
      [fieldName]: [...previousData[fieldName], initialValues],
    }));
  }

  function remove(index: number) {
    get(form.data, fieldName).splice(index, 1);

    form.setData(fieldName, [...get(form.data, fieldName)]);
  }

  function update(index: number, value: any) {
    const entries = Object.entries(value);

    entries.forEach(([k, v]) => form.setData(`${fieldName}.${index}.${k}`, v));
  }

  return { append, remove, update };
}
